export default function runPageAnalytics($rootScope, $analytics, $gzAnalytics, $window) {
  'ngInject';

  $rootScope.$on('$stateChangeSuccess', (event, toState) => {
    let pageName = $gzAnalytics.getPage();
    let index = pageName.indexOf('?');
    if (index !== -1) {
      pageName = pageName.substring(0, index);
    }
    if (window.printos && window.printos.blue && window.printos.blue.gazellePage) {
      window.printos.blue.gazellePage(toState.name, pageName);
    }
  });
}
